import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { Subscription, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SurveysService } from '../../services/surveys/surveys.service';


@Component({
  templateUrl: './surveys.component.html',
  styleUrls: ['./surveys.component.scss']
})
export class SurveysComponent implements OnInit, OnDestroy {
  public surveys = [];

  private subs: Array<Subscription> = [];
  private modalContent: any;
  private modalConfig: any = {
    ariaLabelledBy: 'modal-basic'
  };

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();
  public submitted = false;

  public surveyId: number;
  public form: FormGroup;
  public page = 1;
  public limit = 10;
  public offset = 0;
  public CodeQR: string;

  constructor(
    private fb: FormBuilder,
    private surveysService: SurveysService,
    private authService: AuthenticationService,
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      language: {
        emptyTable: '',
        zeroRecords: 'No hay coincidencias',
        lengthMenu: 'Mostrar _MENU_ elementos',
        search: 'Buscar:',
        info: 'De _START_ a _END_ de _TOTAL_ elementos',
        infoEmpty: 'De 0 a 0 de 0 elementos',
        infoFiltered: '(filtrados de _MAX_ elementos totales)',
        paginate: {
          first: 'Prim.',
          last: 'Últ.',
          next: 'Sig.',
          previous: 'Ant.'
        },
      },
      order:[[1, 'desc']]
    };

    this.subs.push(
      this.surveysService
        .getSurveys()
        .pipe(
          catchError(err => this.authService.handleUnauthorizedError(err))
        )
        .subscribe(data => {
          this.surveys = Array.isArray(data) ? data : (data?.data ?? []);
          this.dtTrigger.next();
        })
    );
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.subs.forEach(sub => sub.unsubscribe());
  }

  public setModalContent(content: any, surveyId: number): void {
    this.surveyId = surveyId;
    this.modalContent = content;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

  public get formState() {
    return this.form.controls;
  }

  public loadPage(page: number) {
    this.subs.push(
      this.surveysService
        .getSurveys()
        .pipe(
          catchError(err => this.authService.handleUnauthorizedError(err))
        )
        .subscribe(data => {
          this.surveys = Array.isArray(data) ? data : (data?.data ?? []);
        })
    );
  }

  public setModalQR(contentqr: any, surveyId: number): void {
    this.surveyId = surveyId;
    this.CodeQR = 'https://morelos.stackcode.io/responder-encuesta/'+this.surveyId
    this.modalContent = contentqr;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

}
